export interface User {
	id: string | null;
	email: string | null;
	firstName: string | null;
	surName: string | null;
}

type Roles =
	| 'admin'
	| 'policy_engine'
	| 'monitoring'
	| 'admin'
	| 'subscriber_provision'
	| 'subscriber_read_only'
	| 'plan_provision'
	| 'plan_read_only'
	| 'system_admin'
	| 'system_admin_read_only'
	| 'policy_engine'
	| 'policy_engine_read_only'
	| 'monitoring'
	| 'monitoring_read_only';

export interface UserData {
	user: User;
	token: string | null;
	refreshToken: string | null;
	apiConsumer: boolean;
	status: 'checking' | 'authenticated' | 'not-authenticated';
	roles: Roles[] | null;
}

export const initialState: UserData = {
	roles: null,
	user: {
		id: null,
		email: null,
		firstName: null,
		surName: null,
	},
	token: null,
	refreshToken: null,
	status: 'checking',
	apiConsumer: false,
};
